/*
 * Legal-magazine topics, in the three site languages. Articles store the
 * category as display text in their own language ("Droit de la famille",
 * "قانون الأسرة"); editorial FAQ store the key. urls.findCategory() maps any
 * of those spellings (or a URL slug) back to one entry here.
 *
 * key:  stable identifier, stored on editorial FAQ
 * ar/fr/en: display names, exactly as the magazine seeds write them
 * slug: URL segment of the topic page per language (/Magazine-Juridique/categorie/<slug>)
 *
 * Plain CommonJS with no dependencies: it runs in node and in the browser.
 */

// Second path segment of a topic page, under the magazine section.
const CATEGORY_SEGMENT = { ar: "تصنيف", fr: "categorie", en: "category" };

const CATEGORIES = [
  {
    key: "practical-guide",
    ar: "دليل عملي",
    fr: "Guide pratique",
    en: "Practical guide",
    slug: { ar: "دليل-عملي", fr: "guide-pratique", en: "practical-guide" },
  },
  {
    key: "family-law",
    ar: "قانون الأسرة",
    fr: "Droit de la famille",
    en: "Family law",
    slug: { ar: "قانون-الأسرة", fr: "droit-de-la-famille", en: "family-law" },
  },
  {
    key: "property",
    ar: "عقارات",
    fr: "Immobilier",
    en: "Property",
    slug: { ar: "عقارات", fr: "immobilier", en: "property" },
  },
  {
    key: "employment-law",
    ar: "قانون الشغل",
    fr: "Droit du travail",
    en: "Employment law",
    slug: { ar: "قانون-الشغل", fr: "droit-du-travail", en: "employment-law" },
  },
  {
    key: "criminal-law",
    ar: "القانون الجزائي",
    fr: "Droit pénal",
    en: "Criminal law",
    slug: { ar: "القانون-الجزائي", fr: "droit-penal", en: "criminal-law" },
  },
  {
    key: "business-law",
    ar: "قانون الأعمال",
    fr: "Droit des affaires",
    en: "Business law",
    slug: { ar: "قانون-الأعمال", fr: "droit-des-affaires", en: "business-law" },
  },
  {
    key: "court-procedures",
    ar: "إجراءات قضائية",
    fr: "Procédures judiciaires",
    en: "Court procedures",
    slug: { ar: "إجراءات-قضائية", fr: "procedures-judiciaires", en: "court-procedures" },
  },
  {
    key: "insurance",
    ar: "التأمين",
    fr: "Assurances",
    en: "Insurance",
    slug: { ar: "التأمين", fr: "assurances", en: "insurance" },
  },
  // Topics the editorial team writes for next (no seeded guide yet).
  {
    key: "digital-law",
    ar: "القانون الرقمي",
    fr: "Droit du numérique",
    en: "Digital law",
    slug: { ar: "القانون-الرقمي", fr: "droit-du-numerique", en: "digital-law" },
  },
  {
    key: "consumer-law",
    ar: "حماية المستهلك",
    fr: "Droit de la consommation",
    en: "Consumer law",
    slug: { ar: "حماية-المستهلك", fr: "droit-de-la-consommation", en: "consumer-law" },
  },
  {
    key: "nationality-civil-status",
    ar: "الجنسية والحالة المدنية",
    fr: "Nationalité et état civil",
    en: "Nationality & civil status",
    slug: { ar: "الجنسية-والحالة-المدنية", fr: "nationalite-et-etat-civil", en: "nationality-civil-status" },
  },
  {
    key: "tax",
    ar: "الجباية",
    fr: "Fiscalité",
    en: "Tax",
    slug: { ar: "الجباية", fr: "fiscalite", en: "tax" },
  },
];

module.exports = { CATEGORIES, CATEGORY_SEGMENT };
